import { includesEnumValue } from '@talos/kyoko';

export const MultilegComboType = {
  SyntheticCross: 'SyntheticCross',
  Delta1Spread: 'Delta1Spread',
  OptionsCalendarSpread: 'OptionsCalendarSpread',
  OptionsVerticalSpread: 'OptionsVerticalSpread',
} as const;
export type MultilegComboType = (typeof MultilegComboType)[keyof typeof MultilegComboType];

const OPTION_TYPES = [MultilegComboType.OptionsVerticalSpread, MultilegComboType.OptionsCalendarSpread] as const;

export function isMultilegOptionComboType(type?: MultilegComboType): boolean {
  return type ? includesEnumValue(OPTION_TYPES, type) : false;
}
